import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../contexts/AuthContext';
import { resolveHome } from '../auth/resolveHome';
import { returnState } from '../auth/returnTo';
import EntryHub from './EntryHub';

function Splash() {
  return (
    <div style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      height: '100vh', fontFamily: 'Vazirmatn, sans-serif', color: '#475569',
    }}>
      در حال بررسی احراز هویت…
    </div>
  );
}

export function RequireAuth({ children }) {
  const { session, loading } = useAuth(); const location = useLocation();
  if (loading) return <Splash />;
  if (!session) return <Navigate to="/login" replace state={returnState(location)} />;
  return children;
}

export function RequireApproved({ children }) {
  const { session, profile, loading } = useAuth(); const location = useLocation();
  if (loading) return <Splash />;
  if (!session) return <Navigate to="/login" replace state={returnState(location)} />;
  if (!profile || profile.status !== 'approved') return <Navigate to="/pending" replace />;
  return children;
}

// admin and super_admin are superusers: they satisfy every role requirement
// (operator, supervisor, admin). Other roles satisfy only their own role.
function roleSatisfies(actual, required) {
  if (actual === required) return true;
  return actual === 'admin' || actual === 'super_admin';
}

export function RequireRole({ role, children }) {
  const { session, profile, loading } = useAuth(); const location = useLocation();
  if (loading) return <Splash />;
  if (!session) return <Navigate to="/login" replace state={returnState(location)} />;
  if (!profile || profile.status !== 'approved' || !roleSatisfies(profile.role, role)) {
    return <Navigate to={resolveHome(session, profile)} replace />;
  }
  return children;
}

export function RootRedirect() {
  const { session, profile, loading } = useAuth();
  if (loading) return <Splash />;
  // An authenticated OFFICE user goes straight to their home; everyone else
  // (unauthenticated, or a field user with only a localStorage token) lands on
  // the unified entry hub to pick their role.
  if (session) return <Navigate to={resolveHome(session, profile)} replace />;
  return <EntryHub />;
}
